import { formatBytes, ImagesViewer as SharedImagesViewer } from '@zg-rentals/satellite-components';
import type { AttachmentsForMessage } from '../MessageAttachments';
import stringUtils from '../../utils/stringUtils';
import {
  emitRachelPreviewAttachmentsEvent,
  RACHEL_PREVIEW_ATTACHMENTS_EVENT_TYPE_ID,
} from '../../constants/clickstreamEvents/attachment';

type Props = {
  imageAttachments: AttachmentsForMessage;
  onClose(): void;
  selectedImageIndex: number;
};

const ImagesViewer = ({ imageAttachments, onClose, selectedImageIndex }: Props): JSX.Element => {
  return (
    <SharedImagesViewer
      imageAttachments={imageAttachments}
      selectedImageIndex={selectedImageIndex}
      onClose={onClose}
      onPreviewAttachmentClick={emitRachelPreviewAttachmentsEvent}
      previewAttachmentEventId={RACHEL_PREVIEW_ATTACHMENTS_EVENT_TYPE_ID}
      formatFileName={stringUtils.capitalize}
      formatFileSize={formatBytes}
    />
  );
};

export default ImagesViewer;
